module.exports = __webpack_public_path__ + "img/2_2-industriale-porto-1.1c1359d8.png";